/**
 * @module
 * The accounts entry: the DUI parts its pages use, the theme, and the root,
 * which picks the page from the URL.
 */
import "@dui/components/button";
import "@dui/components/card";
import "@dui/components/field";
import "@dui/components/input";
import "@dui/components/spinner";
import * as Styles from "./styles.ts";
import "./ui/consent-page.ts";
import "./ui/sign-in-form.ts";
import "./ui/sign-out-page.ts";
import "./ui/accounts-root.ts";

Styles.bootstrap();
document.body.append(document.createElement("accounts-root"));
